// extracted by mini-css-extract-plugin
export var option = "_3q-0";
export var optionCard = "_3q-f";
export var optionContent = "_3q-g";
export var optionIcon = "_3q-i";
export var optionIconBox = "_3q-h";
export var optionLabel = "_3q-j";
export var optionPill = "_3q-m";
export var optionPillBadge = "_3q-p";
export var optionPillIcon = "_3q-n";
export var optionPillLabel = "_3q-o";
export var optionRadio = "_3q-k";
export var optionRadioInner = "_3q-l";
export var optionReveal = "_3q-2";
export var optionRevealDelay0 = "_3q-3";
export var optionRevealDelay1 = "_3q-4";
export var optionRevealDelay10 = "_3q-d";
export var optionRevealDelay11 = "_3q-e";
export var optionRevealDelay2 = "_3q-5";
export var optionRevealDelay3 = "_3q-6";
export var optionRevealDelay4 = "_3q-7";
export var optionRevealDelay5 = "_3q-8";
export var optionRevealDelay6 = "_3q-9";
export var optionRevealDelay7 = "_3q-a";
export var optionRevealDelay8 = "_3q-b";
export var optionRevealDelay9 = "_3q-c";
export var optionSelected = "_3q-1";